import { ColorKeys } from '@droplet-tech-code/core-elements/module/theme';
import { showToast } from '@droplet-tech-code/core-elements/module/ui/Toast';
import { dayjs } from '@droplet-tech-code/core-elements/module/utils/utils.date';
import {
  SupportRequestBackendClient,
  SupportRequestListItemResponse,
} from '@naus-code/naus-admin-types';
import { SupportStatus } from '@naus-code/naus-client-types';

import { translate } from '~/utils/translation.utils';

const supportRequestMap = (dateCloseSR?: string): { [key in SupportStatus]: string } => {
  let closedText = translate('supportRequests.closed');
  if (dateCloseSR) {
    if (dayjs().diff(dateCloseSR, 'days') < 2) {
      closedText = translate('supportRequests.solved');
    }
  }
  return {
    Open: translate('supportRequests.open'),
    Pending: translate('supportRequests.pending'),
    Paused: translate('supportRequests.paused'),
    Closed: closedText,
    Deleted: translate('supportRequests.deleted'),
  };
};

export const displaySupportStatus = (
  supportRequest: SupportRequestBackendClient | SupportRequestListItemResponse,
): string => {
  const status = supportRequest.status;
  //@ts-expect-error
  const displayStatus = supportRequestMap(supportRequest.dateCloseSR)[status];
  if (displayStatus === undefined) {
    return status;
  }
  return displayStatus;
};

export const submitSupportStatus = (
  supportRequest: SupportRequestBackendClient | SupportRequestListItemResponse,
  displayStatus: string,
) => {
  const [status, _value] = Object.entries(
    //@ts-expect-error
    supportRequestMap(supportRequest.dateCloseSR),
  ).find(([_key, value]) => value === displayStatus) || [undefined, undefined];

  if (status === undefined) {
    showToast(translate('supportRequests.statusNotFound'), { type: 'error' });
    return null;
  }

  return status;
};

export const formatMapToFormData = (
  supportRequest: SupportRequestBackendClient | SupportRequestListItemResponse,
) => {
  //@ts-expect-error
  return Object.entries(supportRequestMap(supportRequest.dateCloseSR))
    .map(([value, label]) => {
      if (value === 'Closed') {
        return { label: translate('supportRequests.solved'), value: 'Closed' };
      }
      return { label, value };
    })
    .filter((formData) => formData.value !== 'Deleted');
};

export const getColorFromStatus = (status: SupportStatus): ColorKeys => {
  switch (status) {
    case 'Open':
      return 'primary-light';
    case 'Pending':
      return 'warning-light';
    case 'Paused':
      return 'error-light';
    case 'Closed':
      return 'monochrome-light';
    default:
      return 'monochrome-light';
  }
};
